import React from 'react';
import { useMetricsBaseProps } from '@hooks/useMetricsBaseProps';
import { useInitAnalytics } from '@hooks/useAnalytics';

interface Props {
  children?: React.ReactNode;
  locale?: string;
  accountMappingId: string;
  contactId: string;
}

/**
 * Initialize the Analytics instance in an authenticated session (relies on useMeQuery)
 */
export function useAnalyticsProvider({ locale, accountMappingId, contactId }: Omit<Props, 'children'>): void {
  const baseProperties = useMetricsBaseProps(contactId, accountMappingId, locale);

  // Initialize Analytics
  useInitAnalytics(baseProperties);
}
